import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./styles/app.less";

const app = createApp(App).use(router);

const mount = () => {
  app.mount("#app");
};

// 等首次导航解析完成再挂载：App 首帧即可读到正确的 route.meta（布局分发依赖它，避免闪一下站点外壳）
router.isReady().then(mount, mount);
